import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const SHBackward = () => (
  <ImageIcon src={Images.Backward} alt="sh-backward-icon/" />
);

export default SHBackward;
